import { fork, put, takeEvery, all } from 'redux-saga/effects';
import config from '../../../config/config';
import {
  LogControllerDtoGamePlaySessionLogListRequest,
  PerplayLogApi
} from '../../models/src';
import {
  gameSessionLogList,
  setGameSessionLogPagination,
  setTotalCount,
} from '../../actions/log/gameSessionLogActions';
import { GAMESESSIONLOG_LIST_REQUEST } from '../../constants/log/gameSessionLogConstants';
import { getErrorMessage } from '../../../utils/serverErrorCheck';
import LogControllerDtoGamePlaySessionLogListResponse
  from '../../models/src/model/LogControllerDtoGamePlaySessionLogListResponse';

const api = new PerplayLogApi(config.API_CLIENT);

function* gameSessionLogListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new LogControllerDtoGamePlaySessionLogListRequest();
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;
    requestData.beginDate = payload.beginDate;
    requestData.endDate = payload.endDate;
    requestData.account = payload.account;
    requestData.nftUid = payload.nftUid;
    requestData.campaignNo = payload.campaignNo;
    console.log('requestData: ', requestData);

    const result = yield api.apiPerplayLogGamePlaySessionLogListPost({ logControllerDtoGamePlaySessionLogListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, LogControllerDtoGamePlaySessionLogListResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    yield put(gameSessionLogList(data.list));
    yield put(setTotalCount(data.totalCount));
    yield put(setGameSessionLogPagination(
      payload.page,
      data.totalCount,
      payload.beginDate,
      payload.endDate,
      payload.searchCode,
      payload.searchString,
    ));
    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* gameSessionLogRootSaga() {
  yield all([
    takeEvery(GAMESESSIONLOG_LIST_REQUEST, gameSessionLogListRequestSaga),
  ]);
}

const gameSessionLogSagas = [fork(gameSessionLogRootSaga)];

export default gameSessionLogSagas;
